import React, { useEffect, useState, useRef } from 'react';
function useCountUp(target: number, duration = 2000) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setStarted(true);
    }, {
      threshold: 0.5
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!started) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [started, target, duration]);
  return {
    count,
    ref
  };
}
export function StatsBar() {
  const jobs = useCountUp(300);
  const reviews = useCountUp(150);
  const cities = useCountUp(12);
  return <section className="w-full py-16 px-4" style={{
    backgroundColor: '#0283C7'
  }} data-id="element-752">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-753">
        <div ref={jobs.ref} className="text-center" data-id="element-754">
          <div className="font-bold text-white" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: 'clamp(36px, 5vw, 52px)',
          fontWeight: 900,
          lineHeight: 1
        }} data-id="element-755">
            {jobs.count}+
          </div>
          <p className="text-white text-sm mt-2" style={{
          fontFamily: 'Inter, sans-serif',
          opacity: 0.85
        }} data-id="element-756">
            Jobs Completed
          </p>
        </div>
        <div ref={reviews.ref} className="text-center" data-id="element-757">
          <div className="font-bold text-white" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: 'clamp(36px, 5vw, 52px)',
          fontWeight: 900,
          lineHeight: 1
        }} data-id="element-758">
            {reviews.count}+
          </div>
          <p className="text-white text-sm mt-2" style={{
          fontFamily: 'Inter, sans-serif',
          opacity: 0.85
        }} data-id="element-759">
            Five-Star Reviews
          </p>
        </div>
        <div ref={cities.ref} className="text-center" data-id="element-760">
          <div className="font-bold text-white" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: 'clamp(36px, 5vw, 52px)',
          fontWeight: 900,
          lineHeight: 1
        }} data-id="element-761">
            {cities.count}+
          </div>
          <p className="text-white text-sm mt-2" style={{
          fontFamily: 'Inter, sans-serif',
          opacity: 0.85
        }} data-id="element-762">
            Cities Served
          </p>
        </div>
        <div className="text-center" data-id="element-763">
          <div className="font-bold text-white" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: 'clamp(36px, 5vw, 52px)',
          fontWeight: 900,
          lineHeight: 1
        }} data-id="element-764">
            16
          </div>
          <p className="text-white text-sm mt-2" style={{
          fontFamily: 'Inter, sans-serif',
          opacity: 0.85
        }} data-id="element-765">
            Started at Age
          </p>
        </div>
      </div>
    </section>;
}